import { isBlackFridaySaleEnabled, isLunarNewYearEnabled } from "../helpers/outdoor";

const womensCollectionsMenu = data => `
<ul>
    <li class="sectionhead collection" tabindex="1">
        <span data-prefix="women">${data.Collection}</span>
    </li>
    <div class="mobilefly">
        <li class="mobilehead">
            <span data-prefix="women">${data.Collection}</span>
        </li>
        <li class="s24_veilance CN-block">
            <a href="/c/womens/veilance" data-linkid="women:collection:veilance" data-prefix="women">${data["Veilance Name"]}</a>
        </li>
        <li class="s23_systema">
        <a href="/c/womens/system_a" data-linkid="women:collection:system-a" data-prefix="women">${data["System_A Name"]}</a>
        </li>
        <li class="professional-use JP-block CN-block">
            <a href="/c/womens/professional-use/" data-linkid="women:collection:professional-use" data-prefix="women">${data["Professional Use"]}</a>
        </li>
    </div>
</ul>
`;

const womensClimbingMenu = data => `
<ul>
    <div>
        <li class="sectionhead s24_climbing_gear" tabindex="1">
            <a href="/c/womens/climbing-gear/" data-linkid="women:climbing-gear" data-prefix="women">${data["Climbing Gear"]}</a>
        </li>
        <div class="mobilefly">
            <li class="mobilehead">
                <span data-prefix="women">${data["Climbing Gear"]}</span>
            </li>
            <li class="s23-climbing_gear_harness">
                <a href="/c/womens/climbing-gear/sub-cat=harnesses" data-linkid="women:climbing-gear:harnesses" data-prefix="women">${data["$^nav-harnesses^$"]}</a>
            </li>
            <li class="s23-climbing_gear_ropebags" style="display:none">
                <a href="/c/womens/climbing-gear/sub-cat=rope-bags" data-linkid="women:climbing-gear:rope-bags" data-prefix="women">${data["$^nav-ropeBags^$"]}</a>
            </li>
            <li class="s23-climbing_gear_chalkbags">
                <a href="/c/womens/climbing-gear/sub-cat=chalk-bags" data-linkid="women:climbing-gear:chalk-bags" data-prefix="women">${data["$^nav-chalkBags^$"]}</a>
            </li>
        </div>
    </div>
</ul>
`;

const womensFootwearMenu = data => `
<ul>
    <li class="sectionhead w23_ftw" tabindex="1">
        <a href="/c/womens/footwear/" data-linkid="women:footwear" data-prefix="women">${data.Footwear}</a>
    </li>
    <div class="mobilefly">
        <li class="mobilehead">
            <span data-prefix="women">${data.Footwear}</span>
        </li>
        <li class="s23-ftw_boots">
            <a href="/c/womens/footwear/sub-cat=boots" data-linkid="women:footwear:boots" data-prefix="women">${data["$^nav-boots^$"]}</a>
        </li>
        <li class="s23-ftw_shoes">
            <a href="/c/womens/footwear/sub-cat=shoes" data-linkid="women:footwear:shoes" data-prefix="women">${data["$^nav-shoes^$"]}</a>
        </li>
    </div>
    <li class="spacer">
        <span>&nbsp;</span>
    </li>
</ul>
`;

const womensClothingMenu = data => `
<ul>
    <li class="sectionhead f23_clothing" tabindex="1">
        <a href="/c/womens" data-linkid="women:clothing" data-prefix="women">${data.Clothing}</a>
    </li>
    <div class="mobilefly">
        <li class="mobilehead">
            <span data-prefix="women">${data.Clothing}</span>
        </li>
        <li class="s24_shelljacket">
            <a href="/c/womens/shell-jackets/" data-prefix="women" data-linkid="women:clothing:shell-jackets">${data["Shell Jackets"]}</a>
        </li>
        <li class="s24_insulatedjacket">
            <a href="/c/womens/insulated-jackets/" data-prefix="women" data-linkid="women:clothing:insulated-jackets">${data["Insulated Jackets"]}</a>
        </li>
        <li class="s24_pants">
            <a href="/c/womens/pants/" data-prefix="women" data-linkid="women:clothing:pants">${data.Pants}</a>
        </li>
        <li class="s24_fleece">
            <a href="/c/womens/fleece/" data-prefix="women" data-linkid="women:clothing:fleece">${data.Fleece}</a>
        </li>
        <li class="s24_baselayer JP-block">
            <a href="/c/womens/base-layer/" data-prefix="women" data-linkid="women:clothing:base-layer">${data["Base Layer"]}</a>
        </li>
        <li class="s24_shirtstops">
            <a href="/c/womens/shirts-and-tops/" data-prefix="women" data-linkid="women:clothing:shirts-tops">${data["Shirts & Tops"]}</a>
        </li>
        <li class="s24_shorts">
            <a href="/c/womens/shorts/" data-prefix="women" data-linkid="women:clothing:shorts">${data.Shorts}</a>
        </li>
    </div>
</ul>
`;

const womensPacksMenu = data => `
<ul>
    <li class="sectionhead s24_packs" tabindex="1">
        <a href="/c/womens/packs/" data-prefix="women" data-linkid="women:packs">${data.Packs}</a>
    </li>
    <div class="mobilefly">
        <li class="mobilehead">
            <span data-prefix="women">${data.Packs}</span>
        </li>
        <li class="s23_packs_daypack">
            <a href="/c/womens/packs/sub-cat=daypacks" data-prefix="women" data-linkid="women:packs:daypacks">${data["$^nav-daypacks^$"]}</a>
        </li>
        <li class="s23_packs_multiday">
            <a href="/c/womens/packs/sub-cat=multi-day" data-prefix="women" data-linkid="women:packs:multi-day">${data["$^nav-multiDay^$"]}</a>
        </li>
        <li class="s23_packs_travelcommute">
            <a href="/c/womens/packs/sub-cat=travel-and-commute" data-prefix="women" data-linkid="women:packs:travel-and-commute">${data["$^nav-travelAndCommute^$"]}</a>
        </li>
    </div>
</ul>
`;

const womensAccessoriesMenu = data => `
<ul>
    <li class="sectionhead s24_accessories" tabindex="1">
        <a href="/c/womens/accessories/" data-prefix="women" data-linkid="women:accessories">${data.Accessories}</a>
    </li>
    <div class="mobilefly">
        <li class="mobilehead">
            <span data-prefix="women">${data.Accessories}</span>
        </li>
        <li class="f23_accessories_gloves">
            <a href="/c/womens/accessories/sub-cat=gloves" data-prefix="women" data-linkid="women:accessories:gloves">${data["$^nav-gloves^$"]}</a>
        </li>
        <li class="f23_accessories_toquesbeanies">
            <a href="/c/womens/accessories/sub-cat=toques-and-beanies" data-prefix="women" data-linkid="women:accessories:toques-and-beanies">${data["$^nav-toquesAndBeanies^$"]}</a>
        </li>
        <li class="s24_accessories_hatscaps">
            <a href="/c/womens/accessories/sub-cat=hats-and-caps" data-prefix="women" data-linkid="women:accessories:hats-and-caps">${data["$^nav-hatsAndCaps^$"]}</a>
        </li>
        <li class="f23_socks">
            <a href="/c/accessories?sub-cat=socks&gender=womens" data-prefix="women" data-linkid="women:accessories:socks">${data.Socks}</a>
        </li>
        <li class="s24_accessories_productcare ">
            <a href="/c/womens/accessories/sub-cat=product-care" data-prefix="women" data-linkid="women:accessories:product-care">${data["$^ProductCare^$"]}</a>
        </li>
        <li class="s23_accessories_more">
            <a href="/c/womens/accessories/sub-cat=more" data-prefix="women" data-linkid="women:accessories:more">${data["$^nav-more^$"]}</a>
        </li>
    </div>
</ul>
`;

const womensIntendedUseMenu = data => `
<ul class="intendeduse">
    <li class="sectionhead intended-use" tabindex="1">
        <span data-prefix="women" data-linkid="women:intended-use">${data["$^nav-IntendedUse^$"]}</span>
    </li>
    <div class="mobilefly">
        <li class="mobilehead">
            <span data-prefix="women">${data["$^nav-IntendedUse^$"]}</span>
        </li>
        <li class="s24_alpinerockclimbing">
            <a href="/c/womens/alpine-and-rock-climbing" data-prefix="women" data-linkid="women:intended-use:alpine-and-rock-climbing">${data["Alpine & Rock Climbing"]}</a>
        </li>
        <li class="s24_hiketrekk">
            <a href="/c/womens/hiking-and-trekking" data-prefix="women" data-linkid="women:intended-use:hiking-and-trekking">${data["$^nav-hikingAndTrekking^$"]}</a>
        </li>
        <li class="f23_skisnowboard JP-block">
            <a href="/c/womens/skiing-and-snowboarding" data-prefix="women" data-linkid="women:intended-use:skiing-and-snowboarding">${data["$^nav-skiAndSnowboard^$"]}</a>
        </li>
        <li class="s24_trailrun">
            <a href="/c/womens/trail-running" data-prefix="women" data-linkid="women:intended-use:trail-running">${data["$^nav-trail-running^$"]}</a>
        </li>
        <li class="f23_everyday">
            <a href="/c/womens/everyday" data-prefix="women" data-linkid="women:intended-use:everyday">${data.Everyday}</a>
        </li>
    </div>
</ul>
`;

export const womensShopMoreMenu = (data, country) => `<ul class="shopmore">
        <li class="sectionhead shop-more" tabindex="1">
            <span data-prefix="women">${data["$^nav-ShopMore^$"]}</span>
        </li>
        <div class="mobilefly">
            <li class="mobilehead">
                <span data-prefix="women">${data["$^nav-ShopMore^$"]}</span>
            </li>
            ${
              isBlackFridaySaleEnabled(country)
                ? `<li class="f23_blackfridaysale black-friday">
                <a href="/c/womens/p/black-friday-sale" data-prefix="women" data-linkid="sale:black-friday-sale-womens">${data["Black Friday Sale"]}</a>
            </li>`
                : ""
            }
            <li class="s24_newarrivals">
                <a href="/c/womens/new-arrivals" data-prefix="women" data-linkid="women:shop-more:new-arrivals">${
                  data["New Arrivals"]
                }</a>
            </li>
            <li class="s24_beta_family">
                <a href="/c/womens/beta-family/wid-6j8yr8q9" data-prefix="women" data-linkid="women:shop-more:beta-family">${
                  data["Beta Family"]
                }</a>
            </li>
            <li class="footwear_climb">
                <a href="/shop/footwear/" data-prefix="women" data-linkid="women:shop-more:footwear-innovation">${
                  data["Footwear Innovation"]
                }</a>
            </li>
            <li class="s24_athlete_picks">
                <a href="/c/womens/athlete-picks/wid-rj01vqzl" data-prefix="women" data-linkid="women:shop-more:athlete-picks">${
                  data["Athlete Picks"]
                }</a>
            </li>
            <li class="ski-and-snowboard-gear-guide">
                <a href="/shop/ski-and-snowboard-product-guide" data-prefix="women" data-linkid="women:shop-more:ski-and-snowboard-collection">${
                  data["Ski & Snowboard Collection"]
                }</a>
            </li>
            <li class="s24_gifts_for_her">
                <a href="/c/womens/p/gifts-for-her" data-prefix="women" data-linkid="women:shop-more:gifts-for-her">${
                  data["Gifts for Her"]
                }</a>
            </li>
            <li class="f23_shellfinder">
            <a href="/shop/jacket-finder/womens" data-prefix="women" data-linkid="women:shop-more:shell-finder">
              ${data["$^nav-shellFinder^$"]}
            </a>
            <li class="f23_footwear_finder">
                <a href="/shop/footwear-finder" data-prefix="women" data-linkid="women:shop-more:footwear-finder">
                ${data["$^nav-footwearFinder^$"]}
                </a>
            </li>
            <li class="layering-guide">
                <a href="/shop/womens-layering-guide" data-prefix="women" data-linkid="women:shop-more:layering-guide">${
                  data["$^nav-layering-guide^$"]
                }</a>
            </li>
            <li class="arctype">
                <a href="/c/womens/p/favourites" data-prefix="women" data-linkid="women:shop-more:favourites">${
                  data.Favourites
                }</a>
            </li>
            <li class="s23_exclusives JP-block">
                <a href="/c/womens/exclusives" data-prefix="women" data-linkid="women:shop-more:exclusives">${
                  data.Exclusives
                }</a>
            </li>
            <li class="s24_travel-collection">
                <a href="/shop/womens-travel-collection" data-prefix="women" data-linkid="women:shop-more:travel-collection">${
                  data["$^nav-travelCollection^$"]
                }</a>
            </li>
            <li class="whats-your-warmest">
                <a href="/c/womens/p/whats-your-warmest" data-prefix="women" data-linkid="women:shop-more::whats-your-warmest">${
                  data["What's Your Warmest"]
                }</a>
            </li>
            ${
              isLunarNewYearEnabled()
                ? `<li class="lunar-new-year">
                <a href="/shop/lunar-new-year" data-prefix="women" data-linkid="women:shop-more::lunar-new-year">${data["Year of the Dragon Capsule"]}</a>
            </li>`
                : ""
            }
        </div>
    </ul>`;

const womensShoppingCategoryMenusFdp = (data, country) => `
    ${womensClothingMenu(data)}
    <div class="group">
    ${womensPacksMenu(data)}
    ${womensFootwearMenu(data)}
    </div>
    <div class="group">
    ${womensAccessoriesMenu(data)}
    ${womensClimbingMenu(data)}
    </div>
    <div class="nav-item__divider"></div>
    ${womensIntendedUseMenu(data)}
    <div class="nav-item__divider"></div>
    ${womensCollectionsMenu(data)}
    <div class="nav-item__divider"></div>
    ${womensShopMoreMenu(data, country)}

`;

export const womensShoppingCategoryMenu = (data, country) => womensShoppingCategoryMenusFdp(data, country);
